export function AppIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			width="55"
      height="50"
			viewBox="-10 -10 55 50"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<linearGradient
					gradientUnits="objectBoundingBox"
					x1="0"
					y1="0"
					x2="1"
					y2="1"
					id="gradient_1"
				>
					<stop offset="0%" stopColor="#FFFFFF" stopOpacity="0" />
					<stop offset="100%" stopColor="#FFC107" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					gradientUnits="objectBoundingBox"
					x1="0.17135262"
					y1="0.17250818"
					x2="0.8908453"
					y2="0.61529094"
					id="gradient_2"
				>
					<stop offset="0%" stopColor="#FC466B" />
					<stop offset="100%" stopColor="#3F5EFB" />
				</linearGradient>
				<path
					d="M23.0016 0C31.287 0 38.0016 6.7146 38.0016 15L38.0016 19.3824C38.0016 27.6678 31.287 34.3824 23.0016 34.3824L15 34.3824C6.7146 34.3824 0 27.6678 0 19.3824L0 15C0 6.7146 6.7146 0 15 0L23.0016 0Z"
					id="path_1"
				/>
			</defs>
			<g id="Logo" fillOpacity="1">
				<path
					d="M-950 -1071L-950 -1071L-950 -1036.62L-988 -1036.62L-988 -1071L-950 -1071Z"
					id="Logo"
					fill="none"
					stroke="none"
				/>
				<g id="Group-7">
					<g id="Rectangle">
						<use
							stroke="none"
							fill="url(#gradient_1)"
							{...{ 'xlinkHref': '#path_1' }}
						/>
						<g clipPath="url(#clip_1)">
							<use
								{...{ 'xlinkHref': '#path_1' }}
								fill="none"
								stroke="url(#gradient_2)"
								strokeWidth="6"
							/>
						</g>
					</g>
					<path
						d="M15.3811 16.7384C15.3811 14.4897 17.204 12.6668 19.4527 12.6668C21.7013 12.6668 23.5243 14.4897 23.5243 16.7384C23.5243 18.9871 21.7013 20.81 19.4527 20.81C17.204 20.81 15.3811 18.9871 15.3811 16.7384Z"
						id="Oval"
						fill="url(#gradient_2)"
						fillRule="evenodd"
						stroke="none"
					/>
				</g>
			</g>
		</svg>
	)
}
